import { ValueOf } from '../types';

export const filterObject = <O extends Record<string, ValueOf<O>>>(
  obj: O,
  callback: (key: keyof O, val: ValueOf<O>) => boolean
): Partial<O> => {
  const objectEntries = Object.entries<ValueOf<O>>(obj);
  const filteredEntries = objectEntries.filter(([key, val]) => callback(key, val));
  return Object.fromEntries(filteredEntries) as Partial<O>;
};
